import { all, call, takeLatest } from 'redux-saga/effects'

import agent from 'agent'
import { exportSaga } from './export.sagas'

import * as actions from 'redux/actions/keywordMetrics.actions'

function* exportKeywordMetricsExcelSaga(params) {
  yield call(exportSaga, {
    params: params.payload,
    type: 'xls',
    request: agent.Keywords.exportMetricsExcel,
    requestShared: agent.Share.exportShareMetricsExcel
  })
}

function* exportKeywordMetricsCSVSaga(params) {
  yield call(exportSaga, {
    params: params.payload,
    type: 'csv',
    request: agent.Keywords.exportMetricsCSV,
    requestShared: agent.Share.exportShareMetricsCSV
  })
}

export default function* keywordMetricsSagas() {
  yield all([
    takeLatest(actions.exportDomainKeywordMetricsExcel.type, exportKeywordMetricsExcelSaga),
    takeLatest(actions.exportDomainKeywordMetricsCSV.type, exportKeywordMetricsCSVSaga)
  ])
}
